/******************************************************************************
Chemical Reducer: Handles all interactions & state changes with the chemical
component.
Hawaiian Macadamia Nut Services
Alexander Self
7/23/19
*******************************************************************************/
import { CREATE_CHEMICAL, FETCH_CHEMICALS, SELECT_CHEMICAL, SELECT_CHEMICAL_TO_EDIT,
  ERROR, CLEAR_FORM, EDIT_CHEMICAL, EMAIL_FILE } from '../actions/types';
let initState = {
  chemicalList: [],
  selectedChemical: {},
  edit: {
    isEditing: false,
    editedChemical: {}
  }
};

export default function ChemicalReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_CHEMICALS:
    return { ...state,
      chemicalList: action.payload.sort(sortByTypeName)
    };
    case CREATE_CHEMICAL:
      return { ...state,
        chemicalList: state.chemicalList.concat(action.payload).sort(sortByTypeName)
      };
    case SELECT_CHEMICAL:
      return { ...state,
        selectedChemical: state.chemicalList.find((c) => c.id === action.payload)
      };
    case SELECT_CHEMICAL_TO_EDIT:
      return { ...state,
        edit: {
          isEditing: true,
          editedChemical: state.chemicalList.find((c) => c.id === action.payload)
        }
      }
    case CLEAR_FORM:
      return { ...state,
        edit: {
          isEditing: false,
          editedChemical: {}
        }
      }
    case EDIT_CHEMICAL:
      return { ...state,
        chemicalList: state.chemicalList.filter((c) => c.id !== action.payload.id).concat(action.payload).sort(sortByTypeName),
        edit: {
          isEditing: false,
          editedChemical: {}
        }
      };
    case EMAIL_FILE:
      return state;
    case ERROR:
      return state;
    default:
      return state;
  }
}



function sortByTypeName(a,b) {
  if (a.type < b.type) return -1;
  else if (a.type > b.type) return 1;
  else if (a.type === b.type) {
    if (a.name < b.name) return -1;
    else if (a.name > b.name) return 1;
    return 0;
  }
  return 0;
}























/* END */



// WEBPACK FOOTER //
// ./src/cultivation/reducers/chemical_reducer.js